module.exports = __webpack_public_path__ + "img/horizontal_4_2_pp2_1.b11d3663.png";